module.exports = __webpack_public_path__ + "media/85.2df2d551.wav";